import 'dotenv/config'
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { useMemo, useState, useRef, useEffect } from 'react';
import { Components, createDirectLine, createStore } from 'botframework-webchat';
import DEFAULT_OPTIONS from '../common/defaultStyleOptions'
import { useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import kaiserSvg from '../assets/images/logo.svg';
import KPMobileSVG from '../assets/images/KPMobile.svg';
import endChatSvg from '../assets/images/endChat.svg';
import emojiconPickerSvg from '../assets/images/emojiconPicker.svg';
import attachFileSvg from '../assets/images/attachFile.svg';
import sendSvg from '../assets/images/sendChat.svg';
import useWindowDimensions from '../hooks/useWindowDimensions';
import '../Chat.scss';
import setSendBox from 'botframework-webchat-core/lib/actions/setSendBox';
import submitSendBox from 'botframework-webchat-core/lib/actions/submitSendBox';
import CloseChatPopup from './CloseChatPopup';
import ChatSendBox from './chatInputBox';
import { Layout } from 'antd';
import loadable from "@loadable/component";
import Emoji from "./Emoji";
import FileAttachment from './FileAttachment';
import ErrorModal from './ErrorModal';
import * as adaptiveCardsPackage from 'adaptivecards';
import ConnectionRestoredModal from './ConnectionRestoredModal';
var md = require('markdown-it')();
//import download from 'downloadjs';
const { Content } = Layout;
const { Composer, BasicWebChat, UploadButton, AdaptiveCardContent, HeroCardContent, FileContent } = Components;
var details, chatdetails, filename = '', Downloadattachment = false, endChat = false, fileUploaded = 0, maxfilecountLimit = 1;
var emoji_regex = /^(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])+$/;
const EmojiPicker = loadable(() => import("./EmojiPicker"), {
    fallback: <div id="loading">Loading...</div>
});
var convId;
export const Chat = () => {
    const locationFinder = new URLSearchParams(useLocation().search);
    const { height, width } = useWindowDimensions();
    const [directLine, setDirectLine] = useState(null);
    const [store, setStore] = useState(null);
    const [myError, setError] = useState('');
    const [interacted, setInteracted] = useState(false);
    const [agentJoined, setAgentJoined] = useState(false);
    const [agentName, setAgentName] = useState();
    const [secondaryAgentName, setSecondaryAgentName] = useState();
    const [EnableSendChat, setEnableSendChat] = useState(false);
    const [serviceUrl, setServiceUrl] = useState('');
    const [disableUploadButton, setDisableUploadButton] = useState(false)
    const [pickerOpen, togglePicker] = React.useReducer(state => !state, false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [fileError, setFileError] = useState({ title: '', message: '' })
    const [agentInitials, setAgentInitials] = useState();
    //const [anchorClick,setAnchorClick]=useState(false)
    const [connected, setConnected] = useState(navigator.onLine);
    const [showConnectionRestoredModal, setShowConnectionRestoredModal] = useState(false)
    const [rating, setRating] = useState();
    var notificationTimer;
    var anchorClick = false;
    var env = '';// default env should point to hint1 
    var entrypoint = '';
    var soguid = '';
    var downloadcard = false;
    const child = useRef();
    const BYTES_IN_KB = 1024;    
    const signonUrls = {
        "hint1_signon_url": "https://hint1.kaiserpermanente.org/consumer-sign-on#/signon",
        "hreg1_signon_url": "https://hreg1.kaiserpermanente.org/consumer-sign-on#/signon",
        "hreg2_signon_url": "https://hreg2.kaiserpermanente.org/consumer-sign-on#/signon",
        "dev3_signon_url": "https://wppdev3.kaiserpermanente.org/consumer-sign-on#/signon",
        "dev4_signon_url": "https://wppdev4.kaiserpermanente.org/consumer-sign-on#/signon",
        "prod_signon_url": "https://healthy.kaiserpermanente.org/consumer-sign-on#/signon",
        "signon_url": "https://hreg1.kaiserpermanente.org/consumer-sign-on#/signon"
    };
    var signonUrl = signonUrls.prod_signon_url;
    var keysPressed = {}
    //Middleware for custom Typing
    const typingIndicatorMiddleware = () => next => ({ activeTyping }) => {
        activeTyping = activeTyping != null && activeTyping != undefined ? Object.values(activeTyping) : null;
        var initials_class = 'webchat-custom-avatar-initials-primary';
        const agentInitial = agentName ? agentName.charAt(0) : secondaryAgentName ? secondaryAgentName.charAt(0) : '';
        if (secondaryAgentName) {
            initials_class = 'webchat-custom-avatar-initials-secondary';
        }
        if (activeTyping != null)
            activeTyping = Object.values(activeTyping);
        return (
            !!activeTyping.length && agentJoined && (
                activeTyping[0].role == 'bot' ?
                    (
                        <span className="webchat_typingIndicator">
                            <div className="typing-avatar-wrapper">
                                <div aria-hidden="true" class="webchat__defaultAvatar webchat-typing-bot-avatar">
                                    <div className={`webchat__initialsAvatar ${initials_class} webchat-custom-avatar-initials-message`}>
                                        <div className="webchat__initialsAvatar__initials"><div>{agentInitial}</div></div>
                                    </div>
                                </div>
                            </div>

                            <div class="typing-bubble">Typing...</div>
                        </span>
                    ) : ''
            )
        );
    }

    // const URL_REGEX = /((?:[a-z]+:\/\/)?(?:(?:[a-z0-9\-]+\.)+(?:[a-z]{2}|aero|arpa|biz|com|coop|edu|gov|info|int|jobs|mil|museum|name|nato|net|org|pro|travel|local|internal))(?::[0-9]{1,5})?(?:\/[a-z0-9_\-.~]+)*(?:\/(?:[a-z0-9_\-.]*)(?:\?[a-z0-9+_\-.%=&amp;]*)?)?(?:#[a-zA-Z0-9!$&'(?:)*+.=-_~:@/?]*)?)(?:\s+|$)/;
    const URL_REGEX = /((?:[a-zA-Z]+:\/\/)?(?:(?:[a-zA-Z0-9\-]+\.)+(?:[a-zA-Z]{2}|[aA][eE][rR][oO]|[aA][rR][pP][aA]|[bB][iI][zZ]|[cC][oO][mM]|[cC][oO][oO][pP]|[eE][dD][uU]|[gG][oO][vV]|[iI][nN][fF][oO]|[iI][nN][tT]|[jJ][oO][bB][sS]|[mM][iI][lL]|[mM][uU][sS][eE][uU][mM]|[nN][aA][mM][eE]|[nN][aA][tT][oO]|[nN][eE][tT]|[oO][rR][gG]|[pP][rR][oO]|[tT][rR][aA][vV][eE][lL]|[lL][oO][cC][aA][lL]|[iI][nN][tT][eE][rR][nN][aA][lL]))(?::[0-9]{1,5})?(?:\/[a-zA-Z0-9_\-.~]+)*(?:\/(?:[a-zA-Z0-9_\-.]*)(?:\?[a-zA-Z0-9+_\-.%=&amp;]*)?)?(?:#[a-zA-Z0-9!$&'(?:)*+.=-_~:@/?]*)?)(?:\s+|$)/;
    function renderText(text) {
        console.log('text', text)
        // let parts = text.toLowerCase().split(URL_REGEX)
        let parts = text.split(URL_REGEX)
        console.log('parts[1]', parts[1])
        for (let i = 1; i < parts.length; i += 2) {
            var ref = parts[i];
            console.log('ref', ref)
            console.log('starts with www =', ref.startsWith('www.'))
            if (ref.toLowerCase().startsWith('www.')) {
                ref = 'https://' + ref;
            } 
            // else if (ref.startsWith('www.')) {
            //     ref = ref.replace('www.', 'https://');
            // } 
            else if (!ref.toLowerCase().startsWith('http')) {
                ref = 'https://' + ref;
            }
            parts[i] = <a target='_blank' class='webchat-bot-link' title='open in new window' key={'link' + i} href={ref}>{parts[i]}</a>
        }
        return parts
}
    const handelRightClick = (event) => {
        event.preventDefault();
    }

    async function timeout(delay) {
        return new Promise(res => setTimeout(res, delay));
    }
    const activityMiddleware = () => next => (...otherArgs) => {
        const [card] = otherArgs
        try {
            const timestampStyle = {
                color: 'rgb(118, 118, 118)',
                fontFamily: 'Gotham',
                fontSize: '80%',
                paddingTop: '10px'
            }
            if (card.activity && card.activity.from.role === 'bot' && next(card)) {
                var initials_class = 'webchat-custom-avatar-initials-primary'
                if (card.activity.value && card.activity.name !== 'AgentJoined' && (card.activity.value.type === "Agent" || card.activity.value.type === "Supervisor")) {
                    //  if(card.activity.text && card.activity.value.nickname && !card.activity.text.startsWith(card.activity.value.nickname))                    
                    //     card.activity.text = card.activity.value.nickname + " \n" + card.activity.text; 
                    const agentInitials = card.activity.value.nickname.substring(0, 1).toUpperCase();
                    if (card.activity.value && card.activity.value.IsSecondaryAgent) {
                        initials_class = 'webchat-custom-avatar-initials-secondary'
                    }
                    setAgentInitials(agentInitials)
                    let currentDate = new Date();
                    if (card.activity.timestamp || card.activity.localTimeStamp)
                        currentDate = card.activity.timestamp ? new Date(card.activity.timestamp) : new Date(card.activity.localTimeStamp)
                    return (...otherArgs) => (
                        <div className="webchat-avatar-wrapper">
                            <div aria-hidden="true" class="webchat__defaultAvatar webchat-bot-avatar">
                                <div class={`webchat__initialsAvatar  ${initials_class} webchat-custom-avatar-initials-message`}>
                                    <div class="webchat__initialsAvatar__initials">{agentInitials}</div>
                                </div>
                            </div>
                            <div className="webchat-activity-message-container">
                                {/* {next(card)(...otherArgs)}                                 */}
                                {(card.activity.attachments && card.activity.attachments.length > 0) ? next(card)(...otherArgs) :
                                    <>
                                        <div class="webchat__stacked-layout webchat__stacked-layout--extra-trailing webchat__stacked-layout--show-nub">
                                            <div class="webchat__stacked-layout__main">
                                                <div class="webchat__stacked-layout__avatar-gutter"></div>
                                                <div class="webchat__stacked-layout__content">
                                                    <div aria-roledescription="message" class="webchat__stacked-layout__message-row" role="group">
                                                        <div class="webchat__bubble webchat__bubble--show-nub webchat__stacked-layout__message">
                                                            <div class="webchat__bubble__nub-pad"></div>
                                                            <div class="webchat__bubble__content webchat--css-agent-message">
                                                                <div class="markdown">
                                                                    <p class="webchat--css-agent-message-name">{card.activity.value.nickname}</p>
                                                                    <p class="webchat--css-bot-message">{renderText(card.activity.text)}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="webchat__stacked-layout__alignment-pad"></div>
                                            </div>
                                            <div class="webchat__stacked-layout__status">
                                                <div class="webchat__stacked-layout__avatar-gutter"></div>
                                                <div>
                                                    <span style={timestampStyle}>{currentDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}</span>
                                                </div>
                                                <div class="webchat__stacked-layout__alignment-pad"></div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    );
                } else {
                    if (card.activity && card.activity.name == 'AgentJoined') {
                        const agentInitials = card.activity.text.substring(0, 1);
                        if (card.activity.value && card.activity.value.IsSecondaryAgent) {
                            initials_class = 'webchat-custom-avatar-initials-secondary'
                        }
                        setAgentInitials(agentInitials)
                        return (...otherArgs) => (
                            <div className="webchat-agent-joined-wrapper">
                                <div aria-hidden="true" class="webchat__defaultAvatar webchat-bot-avatar webchat-agent-joined-avatar">
                                    <div class={`webchat__initialsAvatar  ${initials_class} webchat-agent-avatar-joined`}>
                                        <div class="webchat__initialsAvatar__initials">{agentInitials}</div>
                                    </div>
                                </div>
                                <div className="webchat-agent-joined-content">
                                    {card.activity.text}
                                </div>
                            </div>
                        );
                    } else {
                        if (card.activity && card.activity.name == 'User') {

                            card.activity.from.role = 'user';
                        }
                            
                        card.activity.text = card.activity.text.replace(' kp.org ', " `kp.org` ")
                        
                        return (...otherArgs) => (
                            <div className="webchat-wrapper">
                                {next(card)(...otherArgs)}
                            </div>
                        );
                    }
                }
            } else if (card.activity && card.activity.from.role === 'user' && emoji_regex.test(card.activity.text)) {
                let currentDate = new Date()
                if (card.activity.timestamp || card.activity.localTimeStamp)
                    currentDate = card.activity.timestamp ? new Date(card.activity.timestamp) : new Date(card.activity.localTimeStamp)
                return (...otherArgs) => (
                    <div className="webchat-wrapper user-emoji-only-card">
                        <div className="user-emoji-only-text">
                            {card.activity.text}
                        </div>
                        <div class="webchat__stacked-layout__status user-emoji-only-status">
                            <div class="webchat__stacked-layout__avatar-gutter"></div>
                            <div>
                                <span style={timestampStyle}>{currentDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}</span>
                            </div>
                            <div class="webchat__stacked-layout__alignment-pad"></div>
                        </div>
                    </div>
                );
            } else if (card.activity && card.activity.from.role === 'user' && card.activity.text && card.activity.text.includes('kp.org') && !EnableSendChat) {
                card.activity.textFormat = 'plain';
            }

        }
        catch (error) {
            console.log("Error " + error)
        }
        return next(...otherArgs);
    };

    // middleware for activity status before it sends
    const activityStatusMiddleware = () => next => args => {
        // contains event's properties
        const {
            activity: {
                timestamp
            }
        } = args;

        if (timestamp) {
            // format timestamp into hours and minutes
            const currentDate = new Date(timestamp)
            const timestampStyle = {
                color: 'rgb(118, 118, 118)',
                fontFamily: 'Gotham',
                fontSize: '80%',
                paddingTop: '10px'
            }
            return (
                <div>
                    <span style={timestampStyle}>{currentDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}</span>
                </div>
            );
        }

        return next(args)
    }

    const onEmojiClick = (event) => {
        if (event.currentTarget.value)
            child.current.handleEmoji(event.currentTarget.value);
        togglePicker();
    };

    const resetInputChat = () => {
        child.current.resetChatInput();
    };

    const attachmentMiddleware = () => (next) => (card) => {
        const { activities } = store.getState();
        const messageActivities = activities.filter(
            (activity) => activity.type === 'message'
        );
        const recentBotMessage = messageActivities.pop() === card.activity;
        const reconnectCards = activities.filter(
            (activity) => activity.type === 'message' && activity.name !== undefined && activity.name == 'Reconnect'
        );

        if (reconnectCards.length > 0) {
            switch (card.attachment.contentType) {
                case 'application/vnd.microsoft.card.adaptive':

                    return (
                        <AdaptiveCardContent
                            //actionPerformedClassName='card__action--performed'
                            content={card.attachment.content}
                            disabled={true}
                        />
                    );
            }
        }

        // check if user attached a file 
        if (card.activity.attachments != undefined && card.activity.attachments.length > 0 && card.activity.from.role != 'bot') {
            if (card.activity.channelData != undefined) {
                var sizeType = 'KB'
                let fileName = card.attachment.name
                var fileSize = card.activity.channelData.attachmentSizes[0]
                if (fileSize > BYTES_IN_KB * BYTES_IN_KB) {
                    fileSize = (fileSize / (BYTES_IN_KB * BYTES_IN_KB)).toFixed(2)
                    sizeType = 'MB'
                } else if (fileSize > BYTES_IN_KB) {
                    fileSize = (fileSize / BYTES_IN_KB).toFixed(2)
                } else {
                    sizeType = 'B'
                    fileSize = fileSize.toFixed(2)
                }
                return (
                    <FileAttachment fileName={fileName} fileSize={fileSize} sizeType={sizeType} />
                )
            }
        }

        switch (card.attachment.contentType) {
            case 'application/vnd.microsoft.card.adaptive':

                return (
                    <AdaptiveCardContent
                        actionPerformedClassName='card__action--performed'
                        content={card.attachment.content}
                        disabled={!recentBotMessage}
                    />
                );
            case 'application/vnd.microsoft.card.hero':
                return (
                    <HeroCardContent
                        actionPerformedClassName='card__action--performed'
                        content={card.attachment.content}
                        disabled={!recentBotMessage}
                    />
                );

            default:
                return next(card);
        }
    };

    // plays an audible alert 
    const playAlert = () => {
        const audioPlayer = new Audio("pop.mp3")
        audioPlayer.play().then(result => {
        }).catch(e => {
            console.log('error', e);
        })
    }

    // notify user of new message by blinking the tab
    const notifyUser = () => {
        const title = document.title;
        const changeTitle = () => {
            document.title = document.title === title ? `${document.title} - New Message` : title;
        }
        if (!notificationTimer) {
            notificationTimer = setInterval(changeTitle, 1000);
        }
    }

    // show hide endchat model
    const [resetShow, setResetShow] = useState(false);
    const onEndChat = () => {
        setResetShow(true);
    }

    const changeCloseModal = (action) => {
        setResetShow(false);
        if (action === "yes") {
            endChat = true;
            const noLiveChat =  !EnableSendChat ? true:false
            setEnableSendChat(false);
            // store.dispatch(setSendBox("End Chat"));
            // store.dispatch(submitSendBox());
            store.dispatch({
                type: 'WEB_CHAT/SEND_EVENT',
                payload: {
                    name: 'endChat',
                    value: {rating: rating, noLiveChat: noLiveChat}
                }
            });            
        }
        return true;
    }

    const closeFileErrorModal = () => {
        setShowErrorModal(false)
        const scrollingElement = (document.scrollingElement || document.body);
        scrollingElement.scrollTop = scrollingElement.scrollHeight;
    }

    const closeConnectionRestoredModal = () => {
        setShowConnectionRestoredModal(false)
    }

    const uploadButtonClicked = () => {
        const uploadButtonContainer = document.getElementById("uploadButtonContainer")
        if (uploadButtonContainer != null) {
            const uploadButton = uploadButtonContainer.firstChild.firstChild
            uploadButton.removeAttribute('multiple')
        }
    }

    // set interacted to true if the user interacts with the page
    // audio can only play if the user interacts with page
    document.onclick = async function () {
        setInteracted(true)
    }

    document.onkeydown = (event) => {
        keysPressed[event.key] = true
        if((keysPressed['Dead'])) {
            event.preventDefault()
            return false
        }
    }

    document.onkeyup = (event) => {
        keysPressed[event.key] = false
    }

    window.addEventListener('focus', (event) => {
        clearInterval(notificationTimer);
        notificationTimer = undefined;
        document.title = 'Chat with KP';
    })

    window.addEventListener('contextmenu', (event) => {
        event.preventDefault();
    }) 

    window.onload = function () {
        sessionStorage.clear();
        // console.log("Storage Cleared, token removed");

    }

    // listen for incoming activity from the bot 
    window.addEventListener('webchatincomingactivity', (event) => {
        if (interacted && event.data.type === 'message' && event.data.from.role === 'bot') {
            if (agentJoined && document.hidden) {
                playAlert();
                notifyUser();
            }
        }
    })
    window.onbeforeunload = function(e)
    {
     e.stopImmediatePropagation();
     if(!anchorClick)
     {
       //  navigator.sendBeacon(serviceUrl + `/disconnectGenesys?convId=${convId}`);
         fetch(serviceUrl + `/disconnectGenesys?convId=${convId}`, {
             method: 'POST',
     
             headers: {
                 'Content-Type': 'application/json'
             },
             keepalive: true
         }).catch(() => {
             setError('Error: The service is currently unavailable. Please try again later.');
         }); 
         store.dispatch(setSendBox("Closed Browser"));
         store.dispatch(submitSendBox());
       
 }
 anchorClick=false;
 Cookies.remove('chatSession');
}
 
    // window.addEventListener('beforeunload', () => {
     
    //     fetch(serviceUrl + `/disconnectGenesys?convId=${convId}`, {
    //         method: 'POST',
           
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //         keepalive:true
    //     }).catch(() => {
    //         setError('Error: The service is currently unavailable. Please try again later.');
    //     }); 
    //     Cookies.remove('chatSession')
    // })
   
    // window.onbeforeunload =  function () {

    //     // console.log("On browser Close")
       
    //     if (anchorClick !== true) {
           
    //       store.dispatch(setSendBox("Closed Browser"));
    //       store.dispatch(submitSendBox());
                 
    //     }
    //     anchorClick = false;
     
       
         
    // }
    
    window.addEventListener('online', (e) => {
        setConnected(true)
        if (agentJoined) {
            setShowConnectionRestoredModal(true)
        }
    })
    window.addEventListener('offline', (e) => {
        setConnected(false)
    })
    adaptiveCardsPackage.AdaptiveCard.onAnchorClicked = (element, anchor) => {

        //element.stopPropagation()
        //console.log('anchor clicked', anchor);
        anchorClick = true;
        window.open(anchor.href, '_self', 'noreferrer');

        // Returning true will prevent the default behavior
        return true;
    }


    function uuidv4() {
        if (sessionStorage.getItem('from_id') === null) {
            let id = (new Date().getTime().toString() + Math.random()).toString().replace('.', '');
            //console.log("Setting new token value..");
            sessionStorage.setItem('from_id', id);
            return id;
        } else {
            //console.log("Reading existing token value");
            return sessionStorage.getItem('from_id');
        }
    }

    function getServiceUrl() {
        return new Promise(resolve => {
            fetch("/getServiceUrl")
                .then((res) => res.json())
                .then((data) => {
                    setServiceUrl(data.service_url);
                    resolve(data.service_url)
                });
        })
    }

    function containsURL(s) {
        let splitUrl = s.split(/\s+/)
        for (let str of splitUrl) {
            try {
                let url = new URL(str)
                return true
            } catch {
                continue
            }
        }
        return false
    }

    const surveryTrigger = (rating)=>{
        if(rating){
            setRating(rating)
            // store.dispatch({
            //     type: 'WEB_CHAT/SEND_EVENT',
            //     payload: {
            //         name: 'sendSurveyRating',
            //         value: {
            //             rating: rating
            //         }
            //     }
            // });
        }
    }

    useMemo(async () => {
        /** get queryparams values */
        let count = 0;
        let fLinkCount = 0;
        var chatClick = 0;
        const makeQueryParams = () => {
            const params = [];
            let searchParams = new URLSearchParams(window.location.search);
            for (let val of searchParams) {
                params[val[0].toString().toLowerCase()] = val[1];
            }
            return params;
        }
        const payloadParams = makeQueryParams();

        setStore(
            createStore({}, ({ dispatch }) => next => async action => {
                // send chat button click call the send chat service

                let sendChat = document.querySelector('button[title="Send"]');
                // replacing webhcat sendbutton svg with custom svg
                const sendChatSvg = document.createElement("img");
                sendChatSvg.src = sendSvg;
                while (sendChat.firstChild !== null) {
                    sendChat.removeChild(sendChat.firstChild);
                }
                sendChat.appendChild(sendChatSvg);

                // replacing webchat file upload icon  with custon svg
                let fileUpload = document.querySelector('button[title="Upload file"]');
                const fileUploadSvg = document.createElement("img");
                fileUploadSvg.src = attachFileSvg;
                while (fileUpload.firstChild !== null) {
                    fileUpload.removeChild(fileUpload.firstChild);
                }
                fileUpload.appendChild(fileUploadSvg);

                let msg = document.querySelector('input[aria-label="Message input box"]');
                msg = msg.value;
                sendChat.onclick = function () {
                    if (sendChat !== undefined) {
                        if (msg !== undefined && msg.value !== "") {
                            var sendMsg = JSON.stringify({ "message": msg });
                            setTimeout(async () => {
                                await fetch(window.univ.service_url + '/sendChat', {
                                    method: 'POST',
                                    body: sendMsg,
                                    headers: {
                                        'Content-Type': 'application/json'
                                    }
                                }).catch(() => {
                                    setError('Error: The service is currently unavailable. Please try again later.');
                                });
                            })


                        }
                    }
                }

                //dynamic adaptive card title on reconnect
                let showcard = document.querySelectorAll('button[aria-label]');
                showcard.forEach(element => {
                    if (element.ariaLabel != undefined && element.ariaLabel != null && element.ariaLabel.includes('Expand conversation')) {
                        element.onclick = function () {
                            element.ariaLabel = "Collapse conversation";
                        }

                    }
                    if (element.ariaLabel != undefined && element.ariaLabel != null && element.ariaLabel.includes('Collapse conversation')) {
                        element.addEventListener('click', function (e) {
                            e.stopImmediatePropagation();
                            element.ariaLabel = "Expand conversation";
                        });
                    }
                });


                /**Analytics for ff links */
                let flinks = document.querySelectorAll('.ac-container .ac-selectable > .ac-textBlock > p');
                let fcText = "Go to this facility’s detail page";
                for (let i = 0; i < flinks.length; i++) {
                    let flinkText = flinks[i].innerHTML;

                    if (i >= fLinkCount) {
                        flinks[i].addEventListener('click', function (e) {
                            if (flinkText === fcText) {
                                //console.log(e.currentTarget.innerHTML)
                                let eventElement = this.parentNode.parentNode.nextElementSibling.nextElementSibling.firstElementChild.firstChild;
                                if (eventElement) {
                                    var ele = eventElement.innerHTML;
                                }
                                if (ele) {
                                    collectEvents(ele)
                                } else {
                                    collectEvents('')
                                }
                            }
                        })
                        fLinkCount++;
                    }
                };

                let activity = document.querySelectorAll('li[aria-label="activity"], [aria-label="undefined"]');
                if (activity.length === 1) {
                    activity[0].removeAttribute("aria-label")
                } else if (activity.length > 1) {
                    for (let i = 0; i < activity.length; i++) {
                        activity[i].removeAttribute("aria-label")
                    }
                }
                //console.log('action.type ' + action.type);

                // setError('')
                if (action.type === 'DIRECT_LINE/POST_ACTIVITY_REJECTED') {
                    setError('A service error occurred. Please try again later.')
                }

                if (action.type === "WEB_CHAT/SEND_FILES") {
                    setDisableUploadButton(true)
                    if (action.payload && action.payload.files) {
                        if (action.payload.files.length > 1) {
                            alert('File upload failed. Only one file may be uploaded at a time.')
                            setDisableUploadButton(false)
                            return
                        }
                        const file_size = action.payload.files[0].size / 1024 / 1024;
                        if (file_size > 4) {
                            const fileSizeErrorTitle = 'Attached Files Are Too Large'
                            const fileSizeErrorMessage = `There's a limit of 4 megabytes per file and a total limit of 20 megabytes for all files you can attach to each message you send. Try compressing your files or breaking them into smaller files you can send over more than one message.`
                            setFileError({ title: fileSizeErrorTitle, message: fileSizeErrorMessage })
                            setShowErrorModal(true)
                            setDisableUploadButton(false)
                            return;
                        }
                    }
                }

                if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
                    // sessionCheck();
                    // console.log('action.type ' + action.type);
                   // set convID
                   convId=action.payload.directLine.conversationId;
                   console.log("convId "+convId)
                    Cookies.remove('ObSSOCookie');
                    const cookies = JSON.stringify(Cookies.get())

                    // console.log('cookies ' + cookies + Date.now())
                    let fcookie = cookies.substring(1, (cookies.length - 1))
                    fcookie = fcookie.replace(/,/g, ';')
                    fcookie = fcookie.replace(/:/g, '=');
                    fcookie = fcookie.replace(/"/g, '');
                    // console.log('before calling send welcome message event');
                    dispatch({
                        type: 'WEB_CHAT/SEND_EVENT',
                        payload: {
                            name: 'sendWelcomeMessage',
                            value: {
                                message: 'Hello from UI'
                            }
                        }
                    });
                    fetch('/getCookie').then(
                        function (u) { return u.json(); }
                    ).then(
                        function (json) {
                            console.log('cookies from server.js', json)
                            var serverCookies = ''
                            for(var key in json.cookies) {
                                serverCookies += `${key}=${json.cookies[key]};`
                            }
                            console.log('serverCookies', serverCookies)
                            details = { 'cookies': [serverCookies] }

                            dispatch({
                                type: 'WEB_CHAT/SEND_EVENT',
                                payload: {
                                    name: 'webchat/join',
                                    value: {
                                        referrer_page: payloadParams.referrer_page || '',
                                        KPRegion: payloadParams.kpregion,
                                        KPLanguage: payloadParams.kplanguage,
                                        Zip: payloadParams.zip,
                                        browserType: payloadParams.browsertype,
                                        cookie: details
                                    }
                                }
                            });
                        }
                    );
                }

                if (action.type == "WEB_CHAT/SUBMIT_SEND_BOX") {
                    resetInputChat();
                }
                if (action.type === "WEB_CHAT/SEND_POST_BACK") {
                    if (action.payload.value.newSearch && action.payload.value.zipCode.length < 5) {
                        return;
                    }
                }
                if (action.type === "DIRECT_LINE/POST_ACTIVITY") {
                    if (action.payload.activity && action.payload.activity.type === "message") {
                        if (action.payload.activity.text) {
                            action.payload.activity.textFormat = "markdown";
                        }
                    }
                }
                // Allows for buttons of previous cards to get disabled
                if (action.type === 'DIRECT_LINE/INCOMING_ACTIVITY') {

                    const event = new Event('webchatincomingactivity');
                    event.data = action.payload.activity;
                    if (event.data !== undefined) {

                        if (event.data.text != undefined) {
                            const dataText = event.data.text.trim()
                            if (dataText === "User ID Mismatch. Please Log-in again."){
                                Cookies.remove('isSignedOn')
                                Cookies.remove('soguid')
                                Cookies.remove('chatSession')
                                var targetPage = document.URL;
                                if (targetPage.split('?').length > 1) {
                                    targetPage = targetPage.split('?')[0]
                                }
                                var targetHash = window.location.hash.replace('#', '');
                                document.cookie='isSignedOn=false;domain=.kaiserpermanente.org; path=/';   
                                document.cookie='soguid=;domain=.kaiserpermanente.org; path=/';                              
                                document.cookie = 'DSTargetPage=' + targetPage + ';domain=.kaiserpermanente.org; path=/';
                                document.cookie = 'DSTargetHash=' + targetHash + ';domain=.kaiserpermanente.org; path=/';
                                document.cookie = 'envlbl=' + env +  ';domain=.kaiserpermanente.org; path=/';
                               // window.location.href = signonUrl;
                               // window.location.reload();

                            }

                            const text = event.data.text
                            if (containsURL(text)) {
                                event.data.textFormat = "markdown"
                            }
                        }

                        if (event.data.type == 'typing' && event.data.value != undefined) {
                            if (event.data.value.IsSecondaryAgent) {
                                setSecondaryAgentName(event.data.value.nickname);
                                setAgentName(null);
                            } else {
                                setAgentName(event.data.value.nickname);
                                setSecondaryAgentName(null);
                            }
                        }

                        if (event.data.name === 'DisableSendChat') {

                            setEnableSendChat(false);
                        }
                        else
                            if (event.data.name === 'uploadSuccess') {

                                setDisableUploadButton(false);
                                if (event.data.value != undefined && event.data.value.filesUploaded != undefined)
                                    fileUploaded = event.data.value.filesUploaded;
                                if (event.data.value != undefined && event.data.value.maxfiles != undefined)
                                    maxfilecountLimit = event.data.value.maxfiles;
                                let uploadfile = document.querySelector('input[type="file"]');
                                if (uploadfile !== undefined && fileUploaded >= maxfilecountLimit) {
                                    setDisableUploadButton(true)
                                    setFileError({ title: 'Max Number of Files Attached', message: `There is a limit of 5 files you can attach to each chat session.` })
                                    setShowErrorModal(true)

                                    uploadfile.removeAttribute('disabled');
                                }
                            }
                        //console.log('event.data.text '+event.data.text)
                        if (event.data.name === 'AgentJoined') {
                            setAgentJoined(true);
                            if (!EnableSendChat) {
                                setEnableSendChat(true);
                                setDisableUploadButton(false);
                            }

                        }
                        else
                            if (event.data.name === 'EnableSendChat') {
                                Cookies.set('chatSession', "true")

                                setEnableSendChat(true);
                                setDisableUploadButton(true);
                            }
                            else
                                if (event.data.text && event.data.text.toLowerCase() === 'chat ended') {
                                    Cookies.remove("chatSession")
                                    setAgentJoined(false);
                                    setEnableSendChat(false);
                                    // console.log('endChat ' + endChat)

                                    if (endChat == true) {
                                        setTimeout(() => {
                                            window.close();
                                        }, 5000);
                                    }
                                } else if (event.data.name === 'uploadFailExceedLimit') {
                                    setDisableUploadButton(true)
                                }
                                else
                                    if (event.data.name === 'uploadFail') {
                                        setDisableUploadButton(false)
                                    }
                        if (event.data.value !== undefined && event.data.value.DisableUploadButton === true) {
                            setDisableUploadButton(true)
                        }
                        // }

                        if (event.data.attachments !== undefined && event.data.from.role === 'user') {
                            // event.data.text = event.data.attachments[0].name
                            const fileName = event.data.attachments && event.data.attachments[0] && event.data.attachments[0].name
                            var fileSize = event.data.channelData && event.data.channelData.attachmentSizes && event.data.channelData.attachmentSizes[0]
                            var byteFormat = 'kB'
                            if (fileSize > BYTES_IN_KB) {
                                fileSize = Math.round(fileSize / BYTES_IN_KB)
                            }
                            setTimeout(() => {
                                let fromUser = document.querySelectorAll('.webchat__bubble--from-user')
                                fromUser = Object.values(fromUser);
                                let indexOfLastBubble = fromUser.length - 1;
                                let bubble = fromUser[indexOfLastBubble];
                                let bubbleContent = bubble.querySelector('.webchat__bubble__content');
                                if (bubbleContent.childElementCount < 1) {
                                    bubbleContent.innerHTML = `<div style="text-align: center;">${fileName}</div><div>${fileSize} ${byteFormat}</div>`
                                }
                            }, 50);
                        }

                        var channeldata;
                        let buttons = document.querySelectorAll('[role="button"]');
                        let inputs = document.getElementsByClassName("ac-numberInput");
                        let trigger = (event.data.attachments && event.data.attachments[0] && event.data.attachments[0].content) ? event.data.attachments[0].content.trigger : null;

                        if (trigger) {
                            const classNameFromTrigger = {
                                'locationCardTrigger': 'locationCard',
                                'facilityListingsTrigger': 'facility-listings',
                                'facilityDetailsTrigger': 'facility-details'
                            };
                            let children = document.getElementsByClassName('ac-adaptiveCard')
                            setTimeout(() => {
                                let target = children[children.length - 1];
                                if (target && classNameFromTrigger[trigger]) {
                                    target.className += ' ' + classNameFromTrigger[trigger];
                                }
                            }, 0);
                        }

                    }
                    window.dispatchEvent(event);
                }
                return next(action);
            })
        );

        const collectEvents = async (values) => {
            const res = await fetch(serviceUrl + '/log/insights', {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: values })
            })
            const data = await res.json();
            return data;
        }

        setTimeout(async () => {
            const sUrl = await getServiceUrl();
            const res = await fetch(sUrl + '/directline/token', {
                method: 'POST',
            }).catch(() => {
                setError('Error: The service is currently unavailable. Please try again later.');
            });

            const { token } = await res.json();
            setDirectLine(createDirectLine({ token }));
        }, 0);
    }, [])

    setTimeout(async () => {
        //console.log('document url', document.URL)
        env = locationFinder.get('envlbl');
        entrypoint = locationFinder.get('entrypoint');
        if (entrypoint !== undefined && entrypoint !== null && entrypoint !== "") {
            document.cookie = 'entrypoint=' + entrypoint;
        }    
        if (!env && Cookies.get('envlbl')) {
            env = Cookies.get('envlbl')
        }
        console.log('Reading envlbl', env);
        console.log('Reading entrypoint', entrypoint);
        if (env !== undefined && env !== null && env !== "") {
            console.log('Reading envlbl from redirect cookie', env);
            
            document.cookie = "envlbl=" + env;
            switch (env) {
                case 'hint1':
                    signonUrl = signonUrls.hint1_signon_url
                    break;
                case 'hreg1':
                    signonUrl = signonUrls.hreg1_signon_url
                    break;

                case 'hreg2':
                    signonUrl = signonUrls.hreg2_signon_url
                    break;
                case 'dev3':
                    signonUrl = signonUrls.dev3_signon_url
                    break;
                case 'dev4':
                    signonUrl = signonUrls.dev4_signon_url
                    break;
                default:
                    signonUrl = signonUrls.prod_signon_url
            }
            //  window.history.pushState({}, document.title, "/" + "cb");

        } else {
            if (document.URL === 'https://membersvcsbotn.kaiserpermanente.org/secure/cb') {
                signonUrl = signonUrls.hint1_signon_url
                env = 'hint1'
            } else if (document.URL === 'https://membersvcsbotq.kaiserpermanente.org/secure/cb') {
                env = 'hint1'
                signonUrl = signonUrls.hint1_signon_url
            } else if (document.URL === 'https://membersvcsbotu.kaiserpermanente.org/secure/cb') {
                env = 'hreg1'
                signonUrl = signonUrls.hreg1_signon_url
            } else if (document.URL === 'http://localhost:5550/secure/cb') {
                env = 'dev4'
                signonUrl = signonUrls.dev4_signon_url
            } else if (document.URL === 'https://membersvcsbotn.kaiserpermanente.org/cb') {
                signonUrl = signonUrls.hint1_signon_url
                env = 'dev4'
            } else if (document.URL === 'https://membersvcsbotq.kaiserpermanente.org/cb') {
                signonUrl = signonUrls.hint1_signon_url
                env = 'hint1'
                signonUrl = signonUrls.hint1_signon_url
            } else if (document.URL == 'https://membersvcsbotu.kaiserpermanente.org/cb') {
                env = 'hreg1'
                signonUrl = signonUrls.hreg1_signon_url
            } else if (document.URL == 'http://localhost:5550/cb') {
                env = 'dev4'
                signonUrl = signonUrls.dev4_signon_url
            }
        }
        // if (soguid == '' || soguid == undefined || soguid == null || soguid === 'undefined') {                         
        //         window.location.href = signonUrl;
        // }else{

        // }
        //console.log('targetPage', document.URL)
        var targetPage = document.URL;
        if (targetPage.split('?').length > 1) {
            targetPage = targetPage.split('?')[0]
        }
        var targetHash = window.location.hash.replace('#', '');
        var options = ';domain=.kaiserpermanente.org; path=/';

        if (!/isSignedOn=true/.test(document.cookie) && !Cookies.get('chatSession')) {
            document.cookie = 'DSTargetPage=' + targetPage + options;
            document.cookie = 'DSTargetHash=' + targetHash + options;
            document.cookie = 'envlbl=' + env + ';entrypoint=' + entrypoint + options;
            window.location.href = signonUrl;
        } else {
            Cookies.remove('DSTargetPage');
            Cookies.remove('DSTargetHash');
        }
    }, 100)
    
        // const sessionCheck = () =>{  
        //         var remainingSession = undefined;
        //         window.domain = "kaiserpermanente.org";
        //         if (window.opener && window.opener.$kp)
        //             remainingSession = window.opener.$kp.GS.SessionTimeout.remaining;       
        //         else
        //             console.log("no remaining session");
        //         if(remainingSession){
        //             var mins = remainingSession.split(":")[0];            
        //             if(Number(mins) < 6 ){
        //                 console.log("session is less than 6 mins");
        //                 window.opener.$kp.GS.SessionTimeout.resetTimeout('resetForChat');               
        //             }else{
        //                 console.log("session is greater than 5 mins");
        //             }
        //         } 
        // }
        

    useEffect(() => {
        // document.domain = "kaiserpermanente.org"
        // const interval = setInterval(async () =>{   
        //     sessionCheck()
        // }, 300000);
        // return () => clearInterval(interval); 
    }, [])

    return (
        <>
            <div className='main-container'>
                <div className='logo-container'>
                    <div className='logo-wrapper'>
                        <img alt='KP Logo' className='kp-logo' src={kaiserSvg} />
                    </div>
                </div>
                {

                    < div className='chat-container'>
                        <div className='chat-wrapper'>
                            <div className='main-chat'>
                                <Layout className='container'>
                                    {directLine ?
                                        <Content>
                                            {!connected && agentJoined ? <div className="error-overlay">
                                                <div className="error-overlay-content">
                                                    <div className="ellipsis-animation">
                                                        <div className="dot"></div>
                                                        <div className="dot"></div>
                                                        <div className="dot"></div>
                                                    </div>
                                                    <div className="connection-error-header">Connection Lost</div>
                                                    <div>Attempting to restore connection</div>
                                                </div>
                                            </div> : null
                                            }
                                            <>
                                                <Composer
                                                    store={store}
                                                    directLine={directLine}
                                                    userId={uuidv4()}
                                                    styleOptions={{ ...DEFAULT_OPTIONS, hideSendBox: true }}
                                                    activityStatusMiddleware={activityStatusMiddleware}
                                                    attachmentMiddleware={attachmentMiddleware}
                                                    sendTypingIndicator={true}
                                                    typingIndicatorMiddleware={typingIndicatorMiddleware}
                                                    activityMiddleware={activityMiddleware}
                                                >
                                                    <>
                                                        <div className='main-chat-height-container'>
                                                            <div className='main-chat-height'>
                                                                <div className='main-chat-height-wrapper'>
                                                                    <BasicWebChat />
                                                                </div>
                                                                <div className={`${!EnableSendChat || endChat ? 'input-box-disabled' : ''}`}>
                                                                    <ChatSendBox ref={child} store={store} userId={uuidv4()} directline={directLine} />
                                                                </div>
                                                                <div>
                                                                    {resetShow &&
                                                                        <CloseChatPopup show={true} changeShow={changeCloseModal} surveryTrigger={surveryTrigger} rating={rating}/>}
                                                                </div>

                                                                <div>
                                                                    {showErrorModal && <ErrorModal show={true} title={fileError.title} message={fileError.message} closeModal={closeFileErrorModal} />}
                                                                </div>

                                                                <div>
                                                                    {showConnectionRestoredModal && agentJoined && <ConnectionRestoredModal show={true} title="Connection Restored" message="Your connection has been restored." closeModal={closeConnectionRestoredModal} />}
                                                                </div>

                                                                <div className='emoji-container'>
                                                                    {pickerOpen && <EmojiPicker onEmojiClick={onEmojiClick} togglePicker={togglePicker} />}
                                                                </div>                                                                
                                                                <div className='endchat'>
                                                                    <div className={`${!EnableSendChat || endChat ? 'chat-microphone-container input-box-disabled' : 'chat-microphone-container'}`}>
                                                                        <div className={`${!EnableSendChat || endChat ? 'webchat-file-upload input-box-disabled' : 'webchat-file-upload'}`} id="uploadButtonContainer" onClick={uploadButtonClicked} style={disableUploadButton ? { pointerEvents: 'none' } : {}}>
                                                                            <UploadButton store={store} className={disableUploadButton ? 'webchat__send-box__button upload-button-disabled' : 'webchat__send-box__button'} />
                                                                        </div>
                                                                        {/* <Emoji onClick={togglePicker} /> */}
                                                                        <input className={`${!EnableSendChat || endChat ? 'input-box-disabled' : ''}`} type="image" src={emojiconPickerSvg} onClick={togglePicker} />
                                                                    </div>
                                                                    <input className={`${endChat ? 'input-box-disabled' : 'endchat-button'}`} type="image" src={endChatSvg} onClick={onEndChat} />
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </>
                                                </Composer>
                                            </>
                                        </Content>
                                        :
                                        null
                                    }
                                    {((myError !== '') ? <div className='cb-error'>{myError}</div> : <React.Fragment />)}
                                </Layout>
                            </div>
                        </div>
                    </div>
                }
            </div>

        </>
    );
};

export default Chat;
